import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { mediaService } from '@/services/mediaService';
import { getRefreshConfig } from '@/config/refresh.config';

export const useMedia = (filters: Record<string, unknown> = {}) => {
  return useQuery({
    queryKey: ['media', filters],
    queryFn: () => mediaService.list(filters),
    staleTime: 5 * 60 * 1000,
    ...getRefreshConfig('moderate'),
  });
};

export const useUploadMedia = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ file, userId = null }: { file: File; userId?: string | null }) =>
      mediaService.upload(file, userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['media'] });
    },
  });
};

export const useDeleteMedia = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string | number) => mediaService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['media'] });
    },
  });
};
